import UserType from '@/models/Users/UserType';
import FirebaseUserDto from '@/models/Users/FirebaseUserDto';
import IdentityProvider from '@/models/Users/IdentityProvider';

export default class UserDto {
    id: string;
    createdAt: Date;
    createdById: string;
    lastLoggedInAt: Date;
    lastUpdatedById: string;
    lastUpdatedAt: Date;
    username: string;
    userType: UserType;
    identityProvider: IdentityProvider;
    firebaseUser: FirebaseUserDto;
    firstName: string;
    lastName: string;
    avatar: string;
}